import * as Yup from 'yup'
import { formatDate } from 'utils/helpers';

export const signedForms = (consentForms = []) =>
  consentForms.filter(({ attributes }) => attributes?.pdf_url);

export const pendingForms = (consentForms = []) =>
  consentForms.filter(({ attributes }) => !attributes?.pdf_url);

export const isSigned = (consentForms = []) =>
  consentForms.length > 0 && pendingForms(consentForms).length === 0;

export const signedDate = (attributes) => {
  const date = attributes?.created_at;

  return date ? formatDate(date, 'medium') : '';
}

export const allAccepted = (consents = {}, consentForms = []) =>
  consentForms.length > 0 && consentForms.every(({ id }) => consents[id]);

export const setAllConsents = (consentForms = [], status) => {
  const consents = {};

  for (const { id } of consentForms) {
    consents[id] = status;
  }

  return consents;
}

export const getInitialValues = (consentForms = []) => {
  const consents = {};

  for (const { id, attributes } of consentForms) {
    consents[id] = attributes?.status ?? false;
  }

  return {
    consents,
    accept_all: allAccepted(consents, consentForms)
  }
}

export const getValidationSchema = (consentForms = []) => {
  const rules = {};

  for (const { id, attributes } of consentForms) {
    rules[id] = Yup.boolean().oneOf([true], `You must agree to the ${attributes?.title || 'Consent'}`);
  }

  return Yup.object().shape({
    consents: Yup.object().shape(rules)
  })
}
